export default "__VITE_ASSET__Cxn1l$bo__"